export default __webpack_public_path__ + "static/media/stop-icon-small-black.6f6c3507.svg";